import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HighlightsDataService } from '../../../core/services/highlights-data.service';
import { SalesPerformanceDataService } from '../../../core/services/sales-performance-data.service';
import { AuthorizationAwareComponent } from '../../../core/authorization-aware-component';
import { AppState } from '../../../app-state';
import { Store as NgrxStore } from '@ngrx/store';

@Component({
  standalone: false,
  selector: 'mtn-store-detail-dynamic-page',
  templateUrl: './store-detail-dynamic-page.component.html',
  styleUrls: ['./store-detail-dynamic-page.component.scss']
})
export class StoreDetailDynamicPageComponent extends AuthorizationAwareComponent implements OnInit, AfterViewInit {
  highlights: any[] = [];
  salesPerformance: any = { byVolume: [], bySqft: [] };
  showSalesPerformanceFlag = false;

  constructor(
    protected ngrxStore: NgrxStore<AppState>,
    private highlightsDataService: HighlightsDataService,
    private salesPerformanceDataService: SalesPerformanceDataService
  ) {
    super(ngrxStore);
  }

  onAuthorizationChange(): void {}
  onAuthorizationInit(): void {}

  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToHighlights();
    this.subscribeToSalesPerformance();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.renderMiniCharts(), 100);
  }

  private renderMiniCharts(): void {
    const canvases = document.querySelectorAll('.mini-chart');
    canvases.forEach((canvas: HTMLCanvasElement) => {
      const percentile = parseInt(canvas.getAttribute('data-percentile') || '0');
      const color = canvas.getAttribute('data-color') || '#ddd';
      this.drawMiniChart(canvas, percentile, color);
    });
  }

  private drawMiniChart(canvas: HTMLCanvasElement, percentile: number, color: string): void {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 15;
    const startAngle = -Math.PI / 2;
    const endAngle = startAngle + (2 * Math.PI * Math.max(percentile, 1) / 100);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx.strokeStyle = 'rgba(0,0,0,0.1)';
    ctx.lineWidth = 3;
    ctx.stroke();

    if (percentile > 0 || color) {
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.strokeStyle = color || '#ff0000';
      ctx.lineWidth = 3;
      ctx.stroke();
    }
  }

  private subscribeToHighlights(): void {
    this.addSubscription(
      this.highlightsDataService.highlights$.subscribe((highlights: any[]) => {
        this.highlights = highlights || [];
        this.updateSalesPerformanceVisibility();
      })
    );
  }

  private subscribeToSalesPerformance(): void {
    this.addSubscription(
      this.salesPerformanceDataService.salesPerformance$.subscribe((data: any) => {
        this.salesPerformance = data || { byVolume: [], bySqft: [] };
        setTimeout(() => this.renderMiniCharts(), 50);
      })
    );
  }

  private updateSalesPerformanceVisibility(): void {
    const remainingHighlights = Math.max(0, this.highlights.length - 10);
    this.showSalesPerformanceFlag = remainingHighlights <= 5;
  }

  shouldShowSalesPerformance(): boolean {
    return this.showSalesPerformanceFlag;
  }
}
